import { getTranslationFallback } from '../../utils/translation.utils';
import ProductFilterBase from './product-filter-base.model';
import { IProductFilterDTO, IProductFilterValueDTO, ProductFilterTypes } from './product-filter-base.model';

export default class ProductFilterCheckbox extends ProductFilterBase {
  value = false;
  type = ProductFilterTypes.Checkbox;

  static create(data: IProductFilterDTO): ProductFilterCheckbox {
    return Object.assign(new ProductFilterCheckbox(), data, {
      name: getTranslationFallback(`dcp.search.facet.${data.code}`, data.displayName ?? data.name),
      value: (data.values.find((value) => value.selected) || {}).code === 'true',
      visible:
        data.visible && (data.values.find((value) => value.code === 'true') as IProductFilterValueDTO)?.count > 0,
    });
  }

  clone(): ProductFilterCheckbox {
    return ProductFilterCheckbox.create(this);
  }

  isSelected(): boolean {
    return this.value;
  }

  getResetValue(): boolean {
    return false;
  }
}
